function Tick({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="#04709B"
      className={className}
    >
      <path d="M3.61328 13.1844C3.61328 13.1844 7.75895 17.3503 9.88926 22.6254C9.88926 22.6254 17.2 7.97018 22.3871 3.71631C22.3871 3.71631 18.2212 5.20415 9.88926 15.5987C9.88926 15.5987 6.1629 13.1844 3.61328 13.1844Z" />
    </svg>
  );
}

export default Tick;
